"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NarrativesService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var NarrativesService = /** @class */ (function () {
    function NarrativesService() {
    }
    /**
     * Get Narratives
     * User endpoint for seeing their own connections
     * @returns DiscoveryIndex Success
     * @throws ApiError
     */
    NarrativesService.getOwnNarratives = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/narratives',
        });
    };
    /**
     * Index All Narratives
     * Endpoint for indexing all narratives for all builders
     * @returns StatusResponse Successful Response
     * @throws ApiError
     */
    NarrativesService.indexAllNarratives = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/narratives',
        });
    };
    /**
     * Get User Mutual Connections
     * Given a jwt user and a list of users in query params, returns the pairwise
     * mutual connections (unique users connected via any method) and the mutual
     * narratives between the jwt user and each one of the other users.
     * @param uids The ids of the user I want to find mutual connections with
     * @param types
     * @returns MutualNarratives Success
     * @throws ApiError
     */
    NarrativesService.getUserMutualConnections = function (uids, types) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/narratives/mutual',
            query: {
                'uids': uids,
                'types': types,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Team Narratives
     * Given a jwt user, a list of users in query params,
     * and a list of connection types, get how they are connected to each other.
     * @param uids The ids of the users
     * @param connectionTypes
     * @returns TeamNarrative Success
     * @throws ApiError
     */
    NarrativesService.getTeamNarratives = function (uids, connectionTypes) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/narratives/team-narrative',
            query: {
                'uids': uids,
                'connection_types': connectionTypes,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get User Narratives
     * Admin endpoint for seeing a builder's connections
     * @param uid The user id
     * @returns DiscoveryIndex Success
     * @throws ApiError
     */
    NarrativesService.getUserNarratives = function (uid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/narratives/{uid}',
            path: {
                'uid': uid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Index User Narratives
     * Endpoint for indexing a builder's narratives
     * @param uid The id of the user
     * @param requestBody
     * @returns any Success
     * @returns DiscoveryIndex Successful Response
     * @throws ApiError
     */
    NarrativesService.indexUserNarratives = function (uid, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/narratives/{uid}',
            path: {
                'uid': uid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get User Narratives By Agent
     * API key authenticated endpoint for seeing a builder's connections
     * @param uid The user id
     * @returns DiscoveryIndex Success
     * @throws ApiError
     */
    NarrativesService.getUserNarrativesByAgent = function (uid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/narratives/agent/{uid}',
            path: {
                'uid': uid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get User Subgraph
     * Endpoint for seeing the subgraph of builders
     * with respect to a connection type
     * @param requestBody
     * @returns SubgraphResponse Success
     * @throws ApiError
     */
    NarrativesService.getUserSubgraph = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/narratives/subgraph',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    return NarrativesService;
}());
exports.NarrativesService = NarrativesService;
//# sourceMappingURL=NarrativesService.js.map